import { render, staticRenderFns } from "./MonriPay.vue?vue&type=template&id=be4b39cc&scoped=true"
import script from "./MonriPay.vue?vue&type=script&lang=js"
export * from "./MonriPay.vue?vue&type=script&lang=js"
import style0 from "./MonriPay.vue?vue&type=style&index=0&id=be4b39cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b39cc",
  null
  
)

export default component.exports